export default __webpack_public_path__ + "static/media/cal_bg6.b5a736cc.jpg";